module.exports = require('./helpers/bundle-url').getBundleURL('lPpKD') + "desktop.52946903.mp4" + "?" + Date.now();